// Shared admin-ui components: dialogs, save bar, tables, search select, image crop, rich-text editor.
// Spread into an app's catalogs and fed to <AdminUiProvider> through buildAdminUiLabels. Keys are prefixed `adminui.`.
export const adminUiEn = {
  'adminui.close': 'Close',
  'adminui.confirm': 'Confirm',
  'adminui.cancel': 'Cancel',
  'adminui.unsavedChangesRegion': 'Unsaved changes',
  'adminui.unsavedChanges': 'You have unsaved changes',
  'adminui.discard': 'Discard',
  'adminui.saveChanges': 'Save changes',
  'adminui.saving': 'Saving…',
  'adminui.breadcrumb': 'Breadcrumb',
  'adminui.tableLoadError': 'Could not load data.',
  'adminui.tableReload': 'Reload the page to try again.',
  'adminui.select': 'Select…',
  'adminui.searchPlaceholder': 'Search…',
  'adminui.noResults': 'No results',
  'adminui.chooseFile': 'Choose a file',
  'adminui.crop.title': 'Crop image',
  'adminui.crop.hint': 'Drag to reposition. Use the slider or pinch to zoom.',
  'adminui.crop.zoom': 'Zoom',
  'adminui.crop.confirm': 'Crop and use',
  'adminui.crop.saving': 'Saving…',
  'adminui.crop.cancel': 'Cancel',
  'adminui.crop.failed': 'This image could not be read. Try another file.',
  'adminui.rte.label': 'Content',
  'adminui.rte.toolbarLabel': 'Text formatting',
  'adminui.rte.paragraph': 'Paragraph',
  'adminui.rte.heading2': 'Heading',
  'adminui.rte.heading3': 'Subheading',
  'adminui.rte.bold': 'Bold',
  'adminui.rte.italic': 'Italic',
  'adminui.rte.underline': 'Underline',
  'adminui.rte.strike': 'Strikethrough',
  'adminui.rte.orderedList': 'Numbered list',
  'adminui.rte.bulletList': 'Bulleted list',
  'adminui.rte.blockquote': 'Quote',
  'adminui.rte.horizontalRule': 'Divider',
  'adminui.rte.link': 'Link',
  'adminui.rte.linkPrompt': 'Link URL (https://…, /path, mailto:) — leave empty to remove',
  'adminui.rte.image': 'Insert image',
  'adminui.rte.table': 'Insert table',
  'adminui.rte.addRow': 'Add row below',
  'adminui.rte.addColumn': 'Add column right',
  'adminui.rte.deleteTable': 'Delete table',
  'adminui.rte.undo': 'Undo',
  'adminui.rte.redo': 'Redo',
  'adminui.rte.help': 'Headings, lists, quotes, links, images and tables. Pasted formatting outside this set is removed.',
} as const

export const adminUiId: Record<keyof typeof adminUiEn, string> = {
  'adminui.close': 'Tutup',
  'adminui.confirm': 'Konfirmasi',
  'adminui.cancel': 'Batal',
  'adminui.unsavedChangesRegion': 'Perubahan belum disimpan',
  'adminui.unsavedChanges': 'Anda memiliki perubahan yang belum disimpan',
  'adminui.discard': 'Buang',
  'adminui.saveChanges': 'Simpan perubahan',
  'adminui.saving': 'Menyimpan…',
  'adminui.breadcrumb': 'Jejak navigasi',
  'adminui.tableLoadError': 'Gagal memuat data.',
  'adminui.tableReload': 'Muat ulang halaman lalu coba lagi.',
  'adminui.select': 'Pilih…',
  'adminui.searchPlaceholder': 'Cari…',
  'adminui.noResults': 'Tidak ada hasil',
  'adminui.chooseFile': 'Pilih file',
  'adminui.crop.title': 'Potong gambar',
  'adminui.crop.hint': 'Seret untuk menggeser posisi. Gunakan penggeser atau cubit untuk memperbesar.',
  'adminui.crop.zoom': 'Perbesar',
  'adminui.crop.confirm': 'Potong dan gunakan',
  'adminui.crop.saving': 'Menyimpan…',
  'adminui.crop.cancel': 'Batal',
  'adminui.crop.failed': 'Gambar ini tidak dapat dibaca. Coba file lain.',
  'adminui.rte.label': 'Konten',
  'adminui.rte.toolbarLabel': 'Pemformatan teks',
  'adminui.rte.paragraph': 'Paragraf',
  'adminui.rte.heading2': 'Judul',
  'adminui.rte.heading3': 'Subjudul',
  'adminui.rte.bold': 'Tebal',
  'adminui.rte.italic': 'Miring',
  'adminui.rte.underline': 'Garis bawah',
  'adminui.rte.strike': 'Coret',
  'adminui.rte.orderedList': 'Daftar bernomor',
  'adminui.rte.bulletList': 'Daftar berpoin',
  'adminui.rte.blockquote': 'Kutipan',
  'adminui.rte.horizontalRule': 'Pemisah',
  'adminui.rte.link': 'Tautan',
  'adminui.rte.linkPrompt': 'URL tautan (https://…, /path, mailto:) — kosongkan untuk menghapus',
  'adminui.rte.image': 'Sisipkan gambar',
  'adminui.rte.table': 'Sisipkan tabel',
  'adminui.rte.addRow': 'Tambah baris di bawah',
  'adminui.rte.addColumn': 'Tambah kolom di kanan',
  'adminui.rte.deleteTable': 'Hapus tabel',
  'adminui.rte.undo': 'Urungkan',
  'adminui.rte.redo': 'Ulangi',
  'adminui.rte.help': 'Judul, daftar, kutipan, tautan, gambar, dan tabel. Format tempelan di luar daftar ini akan dihapus.',
}
